import { GET_DASHBOARD } from "../contants";

const initialState = {
  dashboard: {
    totalStorage: 0,
    totalViews: 0,
    activeProjects: 0,
    showReviewPrompt: false,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD: {
      const { payload } = action;
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          ...payload,
          totalStorageMB: getTotalStorage(payload.totalStorage),
        },
      };
    }
    default:
      return state;
  }
};

const getTotalStorage = (v) => {
  if (!v) {
    return "0";
  }
  return (v / 1024).toFixed(2);
};

export default reducer;
